module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('v-contactmodal'), _vm._v(" "), _c('v-sidebar', {
    attrs: {
      "activeNavItem": "navLink2"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main-panel"
  }, [_c('v-navbar', {
    attrs: {
      "title": _vm.isAdd ? 'Create RFQ' : 'Edit RFQ'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content",
    on: {
      "click": function($event) {
        return _vm.dissmissAutoCompletes()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form row"
  }, [_c('div', {
    staticClass: "col-9"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Company")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customercompany),
      expression: "customercompany"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocapitalize": "off",
      "autocomplete": "off",
      "autocorrect": "off",
      "autofocus": "",
      "role": "combobox",
      "spellcheck": "false",
      "disabled": _vm.isContractRFQ || _vm.customerSaved
    },
    domProps: {
      "value": (_vm.customercompany)
    },
    on: {
      "keyup": function($event) {
        return _vm.customerCompanyLiveSearch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customercompany = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "customLiveSearch",
    attrs: {
      "id": "customerCompanyLiveSearch"
    }
  }, [_vm._l((_vm.customercompanyrows), function(customerrow, index) {
    return [_c('div', {
      key: index,
      staticClass: "customLiveSearchElement",
      on: {
        "click": function($event) {
          return _vm.customerCompanySelected(customerrow)
        }
      }
    }, [_vm._v(_vm._s(customerrow.display))])]
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customername),
      expression: "customername"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocapitalize": "off",
      "autocomplete": "off",
      "autocorrect": "off",
      "autofocus": "",
      "role": "combobox",
      "spellcheck": "false",
      "disabled": _vm.isContractRFQ || _vm.customerSaved
    },
    domProps: {
      "value": (_vm.customername)
    },
    on: {
      "keyup": function($event) {
        return _vm.customerLiveSearch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customername = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "customLiveSearch",
    attrs: {
      "id": "customerCustomLiveSearch"
    }
  }, [_vm._l((_vm.customerrows), function(customerrow, index) {
    return [_c('div', {
      key: index,
      staticClass: "customLiveSearchElement",
      on: {
        "click": function($event) {
          return _vm.customerSelected(customerrow)
        }
      }
    }, [_vm._v(_vm._s(customerrow.display))])]
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-6"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "customerPO"
    }
  }, [_c('label', {
    attrs: {
      "for": "customerpo"
    }
  }, [_vm._v("PO #")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customerpo),
      expression: "customerpo"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "customerpo",
      "type": "text"
    },
    domProps: {
      "value": (_vm.customerpo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customerpo = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-6"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "customerSales"
    }
  }, [_c('label', {
    attrs: {
      "for": "customersales"
    }
  }, [_vm._v("Sales #")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customersales),
      expression: "customersales"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "customersales",
      "type": "text"
    },
    domProps: {
      "value": (_vm.customersales)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customersales = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-6"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "customerTransferOrder"
    }
  }, [_c('label', {
    attrs: {
      "for": "customertransferorder"
    }
  }, [_vm._v("Transfer Order #")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customertransferorder),
      expression: "customertransferorder"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "customertransferorder",
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": (_vm.customertransferorder)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customertransferorder = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "customer_terms"
    }
  }, [_vm._v("Terms")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.terms),
      expression: "terms"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "customer_terms"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.terms = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "id": "termsdefault"
    }
  }, [_vm._v("EXW Ex-Works")]), _vm._v(" "), _c('option', [_vm._v("FCA Free Carrier")]), _vm._v(" "), _c('option', [_vm._v("CPT Carriage Paid To")]), _vm._v(" "), _c('option', [_vm._v("CIP Carriage & Insurance Paid To")]), _vm._v(" "), _c('option', [_vm._v("DAT Delivered at Terminal")]), _vm._v(" "), _c('option', [_vm._v("DAP Delivered at Place")]), _vm._v(" "), _c('option', [_vm._v("DDP Delivered Duty Paid")]), _vm._v(" "), _c('option', [_vm._v("FAS Free Alongside Ship")]), _vm._v(" "), _c('option', [_vm._v("FOB Free on Board")]), _vm._v(" "), _c('option', [_vm._v("CFR Cost&FreightForwarderServices")]), _vm._v(" "), _c('option', [_vm._v("CIF Cost.Insurance & Freigh ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "customerduedate"
    }
  }, [_vm._v("Due Date")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.duedate),
      expression: "duedate"
    }],
    staticClass: "form-control datetimepicker",
    attrs: {
      "id": "customerduedate",
      "type": "text"
    },
    domProps: {
      "value": (_vm.duedate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.duedate = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "rolodex"
  }, [_vm._v("\n                      " + _vm._s(_vm.customercompany) + "\n                      "), _c('br'), _vm._v(" " + _vm._s(_vm.customeraddress) + "\n                      "), _c('br'), _vm._v(" " + _vm._s(_vm.customercity) + " " + _vm._s(_vm.customerprovince) + "\n                      "), _c('br'), _vm._v(" " + _vm._s(_vm.customerpostal) + "\n                      "), _c('br'), _vm._v(" " + _vm._s(_vm.customercountry) + "\n                    ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Company")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.companyname),
      expression: "companyname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocapitalize": "off",
      "autocomplete": "off",
      "autocorrect": "off",
      "autofocus": "",
      "role": "combobox",
      "spellcheck": "false"
    },
    domProps: {
      "value": (_vm.companyname)
    },
    on: {
      "keyup": function($event) {
        return _vm.shipperCompanyLiveSearch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "customLiveSearch",
    attrs: {
      "id": "shipperCompanyLiveSearch"
    }
  }, [_vm._l((_vm.shippercompanyrows), function(shipperrow, index) {
    return [_c('div', {
      key: 'shipper_' + index,
      staticClass: "customLiveSearchElement",
      on: {
        "click": function($event) {
          return _vm.shipperCompanySelected(shipperrow)
        }
      }
    }, [_vm._v(_vm._s(shipperrow.display))])]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippername),
      expression: "shippername"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.shippername)
    },
    on: {
      "keyup": function($event) {
        return _vm.shipperLiveSearch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shippername = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "customLiveSearch",
    attrs: {
      "id": "shipperCustomLiveSearch"
    }
  }, [_vm._l((_vm.shipperrows), function(shipperrow, index) {
    return [_c('div', {
      key: 'shipper_' + index,
      staticClass: "customLiveSearchElement",
      on: {
        "click": function($event) {
          return _vm.shipperSelected(shipperrow)
        }
      }
    }, [_vm._v(_vm._s(shipperrow.display))])]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "companyPO"
    }
  }, [_c('label', {
    attrs: {
      "for": "companypo"
    }
  }, [_vm._v("PO #")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.companypo),
      expression: "companypo"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "companypo",
      "type": "text"
    },
    domProps: {
      "value": (_vm.companypo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companypo = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "companyRelease"
    }
  }, [_c('label', {
    attrs: {
      "for": "companyrelease"
    }
  }, [_vm._v("Release #")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.companyrelease),
      expression: "companyrelease"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "companyrelease",
      "type": "text"
    },
    domProps: {
      "value": (_vm.companyrelease)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyrelease = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "companyduedate"
    }
  }, [_vm._v("Pick Up")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.companyduedate),
      expression: "companyduedate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|validDate'),
      expression: "'required|validDate'"
    }],
    staticClass: "form-control datetimepicker",
    attrs: {
      "id": "companyduedate",
      "type": "text",
      "name": "pickup date"
    },
    domProps: {
      "value": (_vm.companyduedate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyduedate = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "companyliftgate"
    }
  }, [_vm._v("Lift Gate")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.companyliftgate),
      expression: "companyliftgate"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.companyliftgate = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "id": "liftgatedefault"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('option', [_vm._v("Yes")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "shipper_appt"
    }
  }, [_vm._v("Appointment")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appointment),
      expression: "appointment"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.appointment = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.apptChange()
      }]
    }
  }, [_c('option', [_vm._v("No")]), _vm._v(" "), _c('option', [_vm._v("Yes")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "contactNameInput"
    }
  }, [_c('label', {
    attrs: {
      "for": "contactname"
    }
  }, [_vm._v("Contact Name")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactname),
      expression: "contactname"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "contactname",
      "type": "text"
    },
    domProps: {
      "value": (_vm.contactname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contactname = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "contactPhoneInput"
    }
  }, [_c('label', {
    attrs: {
      "for": "contactphone"
    }
  }, [_vm._v("Contact Phone")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactphone),
      expression: "contactphone"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "contactphone",
      "type": "text"
    },
    domProps: {
      "value": (_vm.contactphone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contactphone = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "rolodex"
  }, [_vm._v("\n                      " + _vm._s(_vm.companyname) + "\n                      "), _c('br'), _vm._v(" " + _vm._s(_vm.companyaddress) + "\n                      "), _c('br'), _vm._v(" " + _vm._s(_vm.companycity) + " " + _vm._s(_vm.companyprovince) + "\n                      "), _c('br'), _vm._v(" " + _vm._s(_vm.companypostal) + "\n                      "), _c('br'), _vm._v(" " + _vm._s(_vm.companycountry) + "\n                    ")]), _vm._v(" "), (_vm.companyAddressCoordinates) ? _c('LeafletMap', {
    attrs: {
      "height": "200px",
      "starting-center": [_vm.companyAddressCoordinates.lat, _vm.companyAddressCoordinates.lng],
      "points": [{
        center: [_vm.companyAddressCoordinates.lat, _vm.companyAddressCoordinates.lng]
      }]
    }
  }) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Company")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.consigneecompany),
      expression: "consigneecompany"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.consigneecompany)
    },
    on: {
      "keyup": function($event) {
        return _vm.consigneeCompanyLiveSearch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.consigneecompany = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "customLiveSearch",
    attrs: {
      "id": "consigneeCompanyLiveSearch"
    }
  }, [_vm._l((_vm.consigneecompanyrows), function(consigneerow, index) {
    return [_c('div', {
      key: 'consigneerow_' + index,
      staticClass: "customLiveSearchElement",
      on: {
        "click": function($event) {
          return _vm.consigneeCompanySelected(consigneerow)
        }
      }
    }, [_vm._v(_vm._s(consigneerow.display))])]
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.consigneename),
      expression: "consigneename"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocapitalize": "off",
      "autocomplete": "off",
      "autocorrect": "off",
      "autofocus": "",
      "role": "combobox",
      "spellcheck": "false"
    },
    domProps: {
      "value": (_vm.consigneename)
    },
    on: {
      "keyup": function($event) {
        return _vm.consigneeLiveSearch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.consigneename = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "customLiveSearch",
    attrs: {
      "id": "consigneeCustomLiveSearch"
    }
  }, [_vm._l((_vm.consigneerows), function(consigneerow, index) {
    return [_c('div', {
      key: 'consigneerow_' + index,
      staticClass: "customLiveSearchElement",
      on: {
        "click": function($event) {
          return _vm.consigneeSelected(consigneerow)
        }
      }
    }, [_vm._v(_vm._s(consigneerow.display))])]
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "consigneePO"
    }
  }, [_c('label', {
    attrs: {
      "for": "consigneepo"
    }
  }, [_vm._v("PO #")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.consigneepo),
      expression: "consigneepo"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "consigneepo",
      "type": "text"
    },
    domProps: {
      "value": (_vm.consigneepo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.consigneepo = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "consigneedate"
    }
  }, [_vm._v("Delivery Date")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.consigneedate),
      expression: "consigneedate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|validDate'),
      expression: "'required|validDate'"
    }],
    staticClass: "form-control datetimepicker",
    attrs: {
      "id": "consigneedate",
      "type": "text",
      "name": "delivery date"
    },
    domProps: {
      "value": (_vm.consigneedate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.consigneedate = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "truck_liftgate"
    }
  }, [_vm._v("Lift Gate")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.consigneeliftgate),
      expression: "consigneeliftgate"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.consigneeliftgate = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "id": "liftgatedefault"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('option', [_vm._v("Yes")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "consigneeappointment"
    }
  }, [_vm._v("Appointment")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.consigneeappointment),
      expression: "consigneeappointment"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "consigneeappointment"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.consigneeappointment = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.consigneeapptChange()
      }]
    }
  }, [_c('option', [_vm._v("No")]), _vm._v(" "), _c('option', [_vm._v("Yes")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "consigneecontactNameInput"
    }
  }, [_c('label', {
    attrs: {
      "for": "consigneecontactname"
    }
  }, [_vm._v("Contact Name")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.consigneecontactname),
      expression: "consigneecontactname"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "consigneecontactname",
      "type": "text"
    },
    domProps: {
      "value": (_vm.consigneecontactname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.consigneecontactname = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "consigneecontactPhoneInput"
    }
  }, [_c('label', {
    attrs: {
      "for": "consigneecontactphone"
    }
  }, [_vm._v("Contact Phone")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.consigneecontactphone),
      expression: "consigneecontactphone"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "consigneecontactphone",
      "type": "text"
    },
    domProps: {
      "value": (_vm.consigneecontactphone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.consigneecontactphone = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "rolodex"
  }, [_vm._v("\n                      " + _vm._s(_vm.consigneecompany) + "\n                      "), _c('br'), _vm._v(_vm._s(_vm.consigneeaddress) + "\n                      "), _c('br'), _vm._v(" " + _vm._s(_vm.consigneecity) + " " + _vm._s(_vm.consigneeprovince) + "\n                      "), _c('br'), _vm._v(" " + _vm._s(_vm.consigneepostal) + "\n                      "), _c('br'), _vm._v(" " + _vm._s(_vm.consigneecountry) + "\n                    ")]), _vm._v(" "), (_vm.consigneeAddressCoordinates) ? _c('LeafletMap', {
    attrs: {
      "height": "200px",
      "starting-center": [_vm.consigneeAddressCoordinates.lat, _vm.consigneeAddressCoordinates.lng],
      "points": [{
        center: [_vm.consigneeAddressCoordinates.lat, _vm.consigneeAddressCoordinates.lng]
      }]
    }
  }) : _vm._e()], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form row"
  }, [_c('div', {
    staticClass: "col-xs-1 col-sm-4 col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "truck_trailertype"
    }
  }, [_vm._v("Trailer Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trailertype),
      expression: "trailertype"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.trailertype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "id": "trailertypedefault"
    }
  }, [_vm._v("TBD")]), _vm._v(" "), _c('option', [_vm._v("Dry Van")]), _vm._v(" "), _c('option', [_vm._v("Flatbed")]), _vm._v(" "), _c('option', [_vm._v("Container Chassis")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1 col-sm-4 col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "truck_suspensiontype"
    }
  }, [_vm._v("Suspension Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.suspensiontype),
      expression: "suspensiontype"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.suspensiontype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "id": "suspensiontypedefault"
    }
  }, [_vm._v("TBD")]), _vm._v(" "), _c('option', [_vm._v("Spring")]), _vm._v(" "), _c('option', [_vm._v("Air Ride")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1 col-sm-4 col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "truck_temperaturecontrol"
    }
  }, [_vm._v("Temperature Control")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempcontrol),
      expression: "tempcontrol"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tempcontrol = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "id": "tempcontroldefault"
    }
  }, [_vm._v("N/A")]), _vm._v(" "), _c('option', [_vm._v("Reefer Fresh")]), _vm._v(" "), _c('option', [_vm._v("Reefer Frozen")]), _vm._v(" "), _c('option', [_vm._v("Heated")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1 col-sm-4 col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "truck_driverassist"
    }
  }, [_vm._v("Driver Assist")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.driverassist),
      expression: "driverassist"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.driverassist = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "id": "driverassistdefault"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('option', [_vm._v("Yes")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1 col-sm-4 col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "truck_mode"
    }
  }, [_vm._v("Mode")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mode),
      expression: "mode"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "id": "stackabledefault"
    }
  }, [_vm._v("TBD")]), _vm._v(" "), _c('option', [_vm._v("FTL")]), _vm._v(" "), _c('option', [_vm._v("LTL")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1 col-sm-4 col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "truck_service"
    }
  }, [_vm._v("Service")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service),
      expression: "service"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.service = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "id": "servicedefault"
    }
  }, [_vm._v("Standard")]), _vm._v(" "), _c('option', [_vm._v("Overnight")]), _vm._v(" "), _c('option', [_vm._v("Expedited")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1 col-sm-4 col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "consigneecod"
    }
  }, [_vm._v("COD")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.truckcod),
      expression: "truckcod"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "consigneecod"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.truckcod = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "id": "consigneecoddefault"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', [_vm._v("No")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1 col-sm-4 col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "dunnagerequired"
    }
  }, [_vm._v("Dunnage Required")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dunnagerequired),
      expression: "dunnagerequired"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "128"
    },
    domProps: {
      "value": (_vm.dunnagerequired)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dunnagerequired = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1 col-sm-8 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "truck_special"
    }
  }, [_vm._v("Special Instructions")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.specialinstructions),
      expression: "specialinstructions"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "truck_special",
      "id": "truck_special",
      "cols": "30",
      "rows": "10",
      "maxlength": "2048"
    },
    domProps: {
      "value": (_vm.specialinstructions)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.specialinstructions = $event.target.value
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingDimensionUnits),
      expression: "shippingDimensionUnits"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "shippingDimensionUnits"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shippingDimensionUnits = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.onDimensionChange($event)
      }]
    }
  }, [_c('option', [_vm._v("in/lbs")]), _vm._v(" "), _c('option', [_vm._v("in/kgs")]), _vm._v(" "), _c('option', [_vm._v("cm/lbs")]), _vm._v(" "), _c('option', [_vm._v("cm/kgs")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-borderless"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center squeeze"
  }), _vm._v(" "), _c('th', {
    staticClass: "text-left",
    staticStyle: {
      "min-width": "320px",
      "max-width": "320px"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Description / Lot")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Quantity")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Stackable")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Length " + _vm._s(_vm.suunitlength))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Width " + _vm._s(_vm.suunitlength))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Height " + _vm._s(_vm.suunitlength))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Weight " + _vm._s(_vm.suunitweight))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Hazard")]), _vm._v(" "), _c('th', {
    staticClass: "text-left",
    staticStyle: {
      "min-width": "120px",
      "max-width": "120px"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('th', {
    staticClass: "text-center squeeze"
  })])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.rows), function(row, shipIndex) {
    return [_c('TertiaryRow', {
      key: 'tertiary_' + shipIndex,
      attrs: {
        "customerCompanyEntity": _vm.customercompanyentity,
        "row": row,
        "shipIndex": shipIndex,
        "readOnly": !_vm.isDispatchable
      },
      on: {
        "removeRow": function($event) {
          return _vm.removeShippingUnit(shipIndex)
        },
        "cloneRow": function($event) {
          return _vm.duplicateShippingUnit(row, shipIndex)
        }
      }
    })]
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "d-block text-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": !_vm.isDispatchable
    },
    on: {
      "click": function($event) {
        return _vm.addShippingUnit()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add Row")]), _vm._v(" "), (!!_vm.customerSaved && _vm.customercompanyentity === _vm.DIVA_COMPANY_ID && !_vm.isAdd) ? [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": !_vm.isDispatchable
    },
    on: {
      "click": function($event) {
        return _vm.fulfillShipment()
      }
    }
  }, [_vm._v(" Item Fullfillment")]), _vm._v(" "), (this.rfq.dispatchStatus != 'Pending') ? _c('span', [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("Ready")]) : _vm._e(), _vm._v(" "), (this.loading) ? _c('p', [_c('ThreeDots')], 1) : _vm._e(), _vm._v(" "), (_vm.fulfillErrorDetails) ? _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.fulfillErrorDetails))]) : _vm._e()] : _vm._e()], 2)])])])]), _vm._v(" "), (_vm.rows.length > 0) ? _c('ShippingSummary', {
    ref: "summary",
    attrs: {
      "rfq": _vm.rfq,
      "rows": _vm.rows
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isAdd) ? _c('UploadDocument', {
    attrs: {
      "showGenerate": true,
      "documents": _vm.documents,
      "rfqId": _vm.rfqIdOnly,
      "rfq": _vm.rfq
    },
    on: {
      "fileUploaded": _vm.saveDocumentToRFQ,
      "deleteUploadedDocument": _vm.deleteDocument
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isAdd) ? _c('UploadDocument', {
    attrs: {
      "showGenerate": false,
      "documents": _vm.documents,
      "saveLocal": true
    },
    on: {
      "fileAdded": _vm.addFileToLocalDocuments,
      "deleteLocalDocument": _vm.deleteLocalDocument
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [(_vm.rfqAssignees.length > 0) ? _c('table', {
    staticClass: "table"
  }, [_vm._m(7), _vm._v(" "), _c('tbody', [_vm._l((_vm.rfqAssignees), function(rfqAssignee, index) {
    return [_c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "position": "relative"
      }
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (rfqAssignee.assigneeCompany),
        expression: "rfqAssignee.assigneeCompany"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "id": 'assigneecompany' + index,
        "name": "assigneecompany",
        "autocomplete": "off"
      },
      domProps: {
        "value": (rfqAssignee.assigneeCompany)
      },
      on: {
        "keyup": function($event) {
          return _vm.assigneeCompanyLiveSearch(index, rfqAssignee)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(rfqAssignee, "assigneeCompany", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "customLiveSearch",
      staticStyle: {
        "margin-top": "-16px",
        "width": "90%"
      },
      attrs: {
        "id": 'assigneeCompanyLiveSearch' + index
      }
    }, [_vm._l((_vm.assigneecompanyrows), function(assigneerow, idx) {
      return [_c('div', {
        key: idx,
        staticClass: "customLiveSearchElement",
        on: {
          "click": function($event) {
            return _vm.assigneeCompanySelected(index, rfqAssignee, assigneerow)
          }
        }
      }, [_vm._v(_vm._s(assigneerow.display))])]
    })], 2)])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "position": "relative"
      }
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (rfqAssignee.assigneeName),
        expression: "rfqAssignee.assigneeName"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "autocapitalize": "off",
        "autocomplete": "off",
        "autocorrect": "off",
        "autofocus": "",
        "role": "combobox",
        "spellcheck": "false",
        "id": 'assignee' + index,
        "name": "assignee"
      },
      domProps: {
        "value": (rfqAssignee.assigneeName)
      },
      on: {
        "keyup": function($event) {
          return _vm.assigneeLiveSearch(index, rfqAssignee)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(rfqAssignee, "assigneeName", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "customLiveSearch",
      staticStyle: {
        "margin-top": "-16px",
        "width": "90%"
      },
      attrs: {
        "id": 'assigneeCustomLiveSearch' + index
      }
    }, [_vm._l((_vm.assigneerows), function(assigneerow, idx) {
      return [_c('div', {
        key: idx,
        staticClass: "customLiveSearchElement",
        on: {
          "click": function($event) {
            return _vm.assigneeSelected(index, rfqAssignee, assigneerow)
          }
        }
      }, [_vm._v(_vm._s(assigneerow.display))])]
    })], 2)])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "form-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (rfqAssignee.duedate),
        expression: "rfqAssignee.duedate"
      }],
      staticClass: "form-control datetimepicker",
      attrs: {
        "id": 'assigneedue' + index,
        "type": "text"
      },
      domProps: {
        "value": (rfqAssignee.duedate)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(rfqAssignee, "duedate", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('button', {
      staticClass: "btn btn-link btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeAssignee(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-trash"
    })])])])]
  })], 2)]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-icon btn-xs btn-success",
    staticStyle: {
      "margin-top": "-7px"
    },
    attrs: {
      "disabled": !_vm.rfqAssignees || (_vm.isContractRFQ && _vm.rfqAssignees.length > 0) || !_vm.consigneeaddress || !_vm.consigneedate || !_vm.companyaddress || !_vm.companyduedate
    },
    on: {
      "click": function($event) {
        return _vm.addAssignee()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add Assignee")]), _vm._v(" "), (_vm.isContractRFQ) ? _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" This is a contract RFQ with one assignee and will have the quote set and awarded automatically.")]) : _vm._e()])])])]), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(_vm.lastEdit))])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.companyaddress),
      expression: "companyaddress"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "name": "ShipperAddress"
    },
    domProps: {
      "value": (_vm.companyaddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyaddress = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.consigneeaddress),
      expression: "consigneeaddress"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "name": "ConsigneeAddress"
    },
    domProps: {
      "value": (_vm.consigneeaddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.consigneeaddress = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showErrors),
      expression: "showErrors"
    }]
  }, [_vm._l((_vm.errors.all()), function(error, index) {
    return _c('p', {
      key: 'error_' + index,
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(error))])
  }), _vm._v(" "), _vm._l((_vm.overweightMsg), function(msg, index) {
    return _c('p', {
      key: 'owerror_' + index,
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(msg))])
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-simple btn-link btn-wd",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.cancelRFQ()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-normal btn-wd",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.saveRFQ(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save Draft")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-wd",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.beforeSendRFQ()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-send"
  }), _vm._v(" Release")]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "col"
  }, [_c('ThreeDots'), _vm._v(" "), _c('span', {
    staticClass: "loading text-muted"
  }, [_vm._v("Saving...")])], 1) : _vm._e()])], 1), _vm._v(" "), _c('v-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Customer")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Shipper")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Consignee")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Truck")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-9"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Shipping Units")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-1"
  }, [_c('div', {
    staticClass: "text-right"
  }, [_c('label', {
    attrs: {
      "for": "shippingDimensionUnits"
    }
  }, [_vm._v("Units")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Assignee(s)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Company")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Due Date")]), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7855eb1d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/rfq/edit.vue
// module id = 743
// module chunks = 0